(function () {
  function ensureOverlay() {
    var overlay = document.getElementById('SimpleLightbox');
    if (overlay) return overlay;

    overlay = document.createElement('div');
    overlay.id = 'SimpleLightbox';
    overlay.className = 'simple-lightbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    // The overlay itself takes the keyboard focus when it opens (not the close
    // button), so arrow keys never make the close button look highlighted.
    overlay.setAttribute('tabindex', '-1');
    overlay.style.outline = 'none';
    overlay.innerHTML =
      '<button type="button" class="simple-lightbox__close" aria-label="Close">' +
      '<svg viewBox="0 0 20 20"><path d="M1 1l18 18M19 1L1 19" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>' +
      '</button>' +
      '<button type="button" class="simple-lightbox__nav simple-lightbox__prev" aria-label="Previous image">' +
      '<svg viewBox="0 0 14 10"><path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4.5 4.5a.5.5 0 010 .708l-4.5 4.5a.5.5 0 11-.708-.708L12.293 5.5H1a.5.5 0 010-1h11.293L8.646 1.146a.5.5 0 01.109-.338z"/></svg>' +
      '</button>' +
      '<button type="button" class="simple-lightbox__nav simple-lightbox__next" aria-label="Next image">' +
      '<svg viewBox="0 0 14 10"><path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4.5 4.5a.5.5 0 010 .708l-4.5 4.5a.5.5 0 11-.708-.708L12.293 5.5H1a.5.5 0 010-1h11.293L8.646 1.146a.5.5 0 01.109-.338z"/></svg>' +
      '</button>' +
      '<img class="simple-lightbox__img" src="" alt="">';
    document.body.appendChild(overlay);

    var closeBtn = overlay.querySelector('.simple-lightbox__close');
    var prevBtn = overlay.querySelector('.simple-lightbox__prev');
    var nextBtn = overlay.querySelector('.simple-lightbox__next');
    var img = overlay.querySelector('.simple-lightbox__img');

    var items = [];
    var currentIndex = 0;
    var lastTrigger = null;

    function updateImage() {
      if (!items.length) return;
      var item = items[currentIndex];
      img.src = item.src;
      img.alt = item.alt;
      var hideNav = items.length <= 1;
      prevBtn.hidden = hideNav;
      nextBtn.hidden = hideNav;
    }

    function showPrev() {
      if (items.length <= 1) return;
      currentIndex = (currentIndex - 1 + items.length) % items.length;
      updateImage();
    }

    function showNext() {
      if (items.length <= 1) return;
      currentIndex = (currentIndex + 1) % items.length;
      updateImage();
    }

    function close() {
      overlay.classList.remove('simple-lightbox--open');
      img.src = '';
      items = [];
      document.body.style.overflow = '';
      if (lastTrigger && typeof lastTrigger.focus === 'function') {
        try {
          lastTrigger.focus({ preventScroll: true });
        } catch (e) {}
      }
      lastTrigger = null;
    }

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', showPrev);
    nextBtn.addEventListener('click', showNext);
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) close();
    });
    document.addEventListener('keydown', function (event) {
      if (!overlay.classList.contains('simple-lightbox--open')) return;
      if (event.key === 'Escape') {
        close();
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showPrev();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        showNext();
      }
    });

    var touchStartX = 0;
    var touchEndX = 0;
    overlay.addEventListener(
      'touchstart',
      function (event) {
        touchStartX = event.changedTouches[0].screenX;
      },
      { passive: true }
    );
    overlay.addEventListener(
      'touchend',
      function (event) {
        touchEndX = event.changedTouches[0].screenX;
        var threshold = 40;
        var diff = touchStartX - touchEndX;
        if (Math.abs(diff) < threshold) return;
        if (diff > 0) {
          showNext();
        } else {
          showPrev();
        }
      },
      { passive: true }
    );

    overlay.openGallery = function (galleryItems, startIndex, trigger) {
      items = galleryItems;
      currentIndex = startIndex;
      lastTrigger = trigger || null;
      updateImage();
      overlay.classList.add('simple-lightbox--open');
      document.body.style.overflow = 'hidden';
      overlay.focus({ preventScroll: true });
    };

    return overlay;
  }

  function getGalleryData(trigger) {
    var container = trigger.closest('.product__media-list') || document;
    var triggerEls = Array.prototype.slice.call(container.querySelectorAll('[data-lightbox-src]'));
    var items = triggerEls.map(function (el) {
      return { src: el.getAttribute('data-lightbox-src'), alt: el.getAttribute('data-lightbox-alt') || '' };
    });
    var startIndex = triggerEls.indexOf(trigger);
    return { items: items, startIndex: startIndex === -1 ? 0 : startIndex };
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-lightbox-src]');
    if (!trigger) return;
    // Zoom is desktop only: on screens narrower than 750px (the theme's mobile
    // breakpoint) a tap on a product image does nothing.
    if (window.matchMedia('(max-width: 749px)').matches) return;
    event.preventDefault();
    var overlay = ensureOverlay();
    var data = getGalleryData(trigger);
    overlay.openGallery(data.items, data.startIndex, trigger);
  });
})();
